<template>
  <div
    :id="'cem-card-item-inner-' + props.item.id"
    style="width: 100%"
    :class="{ clickabledCanvas: Boolean(popupId || chart_link) }"
  ></div>
  <div :id="'tooltip-card-item-' + props.item.id" class="tooltip-card-item">
    <div class="tooltip-card-item__header">
      <p>{{ titleTooltip }}</p>
      <i class="ri-close-circle-line" @click="closeTooltipCardItem"></i>
    </div>
    <div
      class="tooltip-card-item__content"
      v-html="MethodService.purifyHTML(markdownToHTML(contentTooltip))"
      v-if="contentTooltip"
    ></div>
    <div class="tooltip-card-item__content--nodata" v-else>
      {{ $t("t_no_description") }}
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, onMounted, watch, ref, reactive } from "vue";
import MethodService from "../../service/MethodService";
import Data from "../../components/CardItemsConfig/dataFormCardItemsConfig";
import { marked } from "marked";
import * as echarts from "echarts";
import { Card_item } from "cem-probe-api";
import { GridStack } from "gridstack";
import { useUrlPopupStore } from "@/stores/urlPopupStore";
const storeUrlPopup = useUrlPopupStore();
const colorDefaultGradientAreaChart = reactive({
  value: MethodService.copyObject(Data.colorDefaultGradientAreaChart),
});
const emit = defineEmits(["showDialogDashboardPopup"]);
const props = defineProps({
  item: Card_item,
  itemData: null,
  grid: GridStack,
  dataChartOption: Object,
});
const titleTooltip = ref();
const contentTooltip = ref();
const colorGradient = ref([]);
const rotateLabel = ref(0);
const chartTitle = ref();
const chartUI = reactive({
  smooth: false,
});
const chart_link = ref("");
const popupId = ref("");
const hasColumnLink = (i) => {
  if (props.dataChartOption) {
    return !!(
      props.dataChartOption.data_serials[i - 1]?.popup?.popup_id ||
      props.dataChartOption.data_serials[i - 1]?.link ||
      props.dataChartOption.chart_link
    );
  } else {
    return !!(
      props.item.chart?.data_serials[i - 1]?.popup?.popup_id ||
      props.item.chart?.data_serials[i - 1]?.link ||
      props.item.chart?.chart_link
    );
  }
};
const hasLineLink = (i) => {
  if (props.dataChartOption) {
    return !!(
      props.dataChartOption.data_serials[i - 1]?.popup?.popup_id ||
      props.dataChartOption.data_serials[i - 1]?.link
    );
  } else {
    return !!(
      props.item.chart?.data_serials[i - 1]?.popup?.popup_id ||
      props.item.chart?.data_serials[i - 1]?.link
    );
  }
};
const isNullValue = (data, index) => {
  return (
    (data[index + 1] === "" ||
      data[index + 1] === null ||
      data[index + 1] === undefined) &&
    index + 1 < data.length
  );
};
const closeTooltipCardItem = () => {
  const tooltipDom = document.getElementById(
    `tooltip-card-item-${props.item.id}`
  );
  tooltipDom.classList.remove("showTooltip");
  titleTooltip.value = undefined;
  contentTooltip.value = undefined;
};
const markdownToHTML = (text) => {
  if (!text) return;
  text = text.toString();
  return marked(text);
};
const renderColorLine = (index) => {
  let color = "";
  if (colorGradient.value.length == 0) {
    color = colorDefaultGradientAreaChart.value[index - 1][0];
  } else {
    if (!colorGradient.value[index - 1]?.line_color) {
      color = colorDefaultGradientAreaChart.value[index - 1][0];
    } else color = colorGradient.value[index - 1].line_color;
  }
  return color;
};
const renderColorGradient = (index) => {
  if (!index) return;
  let colorGradientObj = {};
  if (colorGradient.value.length == 0) {
    colorGradientObj = {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {
          offset: 0,
          color: colorDefaultGradientAreaChart.value[index - 1][1],
        },
        {
          offset: 1,
          color: colorDefaultGradientAreaChart.value[index - 1][2],
        },
      ]),
    };
  } else {
    if (
      colorGradient.value[index - 1]?.bg_color.color &&
      !colorGradient.value[index - 1]?.bg_color.to_color
    ) {
      colorGradientObj = {
        opacity: 1,
        color: colorGradient.value[index - 1]?.bg_color.color,
      };
    } else if (
      colorGradient.value[index - 1]?.bg_color.color &&
      colorGradient.value[index - 1]?.bg_color.to_color
    ) {
      colorGradientObj = {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: colorGradient.value[index - 1].bg_color.color,
          },
          {
            offset: 1,
            color: colorGradient.value[index - 1].bg_color.to_color,
          },
        ]),
      };
    } else {
      colorGradientObj = {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: colorDefaultGradientAreaChart.value[index - 1][1],
          },
          {
            offset: 1,
            color: colorDefaultGradientAreaChart.value[index - 1][2],
          },
        ]),
      };
    }
  }

  return colorGradientObj;
};
const renderDataValue = (data, indexData) => {
  const arr = data.data.map((row) => row[indexData]) || [];
  const newData = [];

  if (arr.length > 0) {
    arr.forEach((item, index) => {
      const isInvalid = ["-", "NA", "", null, undefined].includes(item);
      newData.push({
        value: isInvalid ? null : Number(item),
        symbol: "circle",
        itemStyle: {
          color: renderColorLine(indexData),
          opacity: isNullValue(arr, index) ? 1 : 0,
        },
      });
    });
  }

  return newData;
};
const render = (data) => {
  if (!data || data.length == 0) return;
  const chartDom = document.getElementById(
    `cem-card-item-inner-${props.item.id}`
  );
  const tooltipDom = document.getElementById(
    `tooltip-card-item-${props.item.id}`
  );
  const myChart = echarts.init(chartDom);
  const option = {
    grid: {
      left: "3%",
      top: chartTitle.value.show ? 40 : 20,
      right: 20,
      bottom: 20,
      containLabel: true,
    },
    title: chartTitle.value.show
      ? {
          text: chartTitle.value.text,
          textStyle: {
            fontSize: chartTitle.value.textStyle.fontSize,
            color: chartTitle.value.textStyle.color,
          },
        }
      : null,
    tooltip: {
      trigger: "axis",
      backgroundColor: "#1c1c1c",
      borderColor: "#1C1C1C",
      borderRadius: 14,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      axisPointer: {
        type: "shadow",
        label: {
          show: false,
          formatter: function (params) {
            return data.columns[0].title + ": " + params.value;
          },
        },
      },
    },
    xAxis: {
      type: "category",
      data: data.data.map((col) => col[0]),
      axisLabel: {
        rotate: rotateLabel.value,
        color: "#1c1c1c",
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        color: "#1c1c1c",
      },
      min: props.dataChartOption
        ? props.dataChartOption.y_axis.min
        : props.item.chart.y_axis.min,
      max: props.dataChartOption
        ? props.dataChartOption.y_axis.max
        : props.item.chart.y_axis.max,
      splitLine: {
        lineStyle: {
          color: "#D9E5FF",
          type: "dashed",
          width: 1.5,
        },
      },
    },
    series: [
      {
        name: data.columns[1].title,
        //data: data.data.map((row) => row[1]), => thử sửa lại cách hiển thị các vị trí k có giá trị là 1 điểm
        data: renderDataValue(data, 1),
        link: props.dataChartOption
          ? props.dataChartOption.data_serials[0]?.popup?.popup_id ||
            props.dataChartOption.data_serials[0]?.link ||
            props.dataChartOption.chart_link ||
            undefined
          : props.item.chart?.data_serials[0]?.popup?.popup_id ||
            props.item.chart?.data_serials[0]?.link ||
            props.item.chart?.chart_link ||
            undefined,
        type: "line",
        cursor: hasColumnLink(1) ? "pointer" : "default",

        smooth: chartUI.smooth,
        areaStyle: renderColorGradient(1),
        // thêm markLine trường hợp có ....
        markArea: {
          data: data?.alert?.data?.map((item) => {
            return [
              {
                name: item.label,
                xAxis: item.xvalue_from,
                // màu cột
                itemStyle: {
                  color: item.bgcolor,
                },
                // màu chữ
                label: {
                  color: item.textcolor,
                  name: item.tooltip,
                },
              },
              {
                xAxis: item.xvalue_to,
              },
            ];
          }),
        },

        // cấu hình hiển thị điểm trên đường
        showAllSymbol: "all",
        showSymbol: true,
        symbolSize: 5,
        lineStyle: {
          width: 2,
        },
        itemStyle: {
          borderWidth: 0,
        },
        emphasis: hasLineLink(1)
          ? {
              focus: "series",
              symbolSize: 20, // kích thước khi hover
              itemStyle: {
                color: renderColorLine(1),
                borderColor: renderColorLine(1),
                opacity: 1,
                borderWidth: 2,
              },
            }
          : null,
        color: renderColorLine(1),
      },
    ],
  };

  myChart.setOption(option);
  myChart.getZr().on("dblclick", function (event) {
    if (!event.target)
      if (popupId.value) {
        const chartUrl = MethodService.renderLinkChart(
          {
            x: event?.name,
            y: event?.seriesName,
            value: event?.data,
          },
          null
        );
        storeUrlPopup.initUrlPopup();
        storeUrlPopup.pushUrlPopup(chartUrl);
        emit("showDialogDashboardPopup", popupId.value, chartUrl);
      } else if (chart_link.value)
        window.open(
          MethodService.renderLinkChart(
            {
              x: event?.name,
              y: event?.seriesName,
              value: event?.data,
            },
            chart_link.value
          )
        );
  });
  myChart.on("click", function (params) {
    if (!params) return;
    if (params.componentType === "markArea") {
      titleTooltip.value = params.data?.name || undefined;
      contentTooltip.value = params.data?.label?.name || undefined;
      if (titleTooltip.value && contentTooltip.value)
        tooltipDom.classList.add("showTooltip");
    }
  });
  myChart.on("dblclick", function (params) {
    if (option.series[0].link) {
      let regex = /^[0-9a-fA-F]{24}$/;
      if (option.series[0].link.match(regex)) {
        // có cấu hình link dashboard popup
        MethodService.isDashboardPopup(props.item?.card_id).then((result) => {
          if (result) return;
          const chartUrl = MethodService.renderLinkChart(
            {
              x: params?.name,
              y: params?.seriesName,
              value: params?.value || params?.data?.value,
            },
            null
          );
          storeUrlPopup.initUrlPopup();
          storeUrlPopup.pushUrlPopup(chartUrl);
          emit("showDialogDashboardPopup", option.series[0].link, chartUrl);
        });
      } else
        window.open(
          MethodService.renderLinkChart(
            {
              x: params?.name,
              y: params?.seriesName,
              value: params?.value || params?.data?.value,
            },
            option.series[0].link
          )
        );
    }
  });
};

onMounted(() => {
  chartUI.smooth = props.dataChartOption
    ? props.dataChartOption.smooth
    : props.item.chart.smooth;
  chartTitle.value = props.dataChartOption
    ? props.dataChartOption.title
    : props.item.chart.title;
  colorGradient.value = props.dataChartOption
    ? props.dataChartOption.data_serials
    : props.item.chart.data_serials;
  rotateLabel.value = props.dataChartOption
    ? props.dataChartOption.y_axis.axisLabel?.rotate ?? 0
    : props.item.chart.y_axis.axisLabel?.rotate ?? 0;
  chart_link.value = props.dataChartOption
    ? props.dataChartOption.chart_link
    : props.item.chart.chart_link;
  popupId.value = props.dataChartOption
    ? props.dataChartOption.popup?.popup_id
    : props.item.chart.popup?.popup_id;
  render(props.itemData);
});
watch(
  () => props.itemData,
  (data) => render(data)
);
</script>
<style scoped></style>
